import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BdeoToastService } from '@bdeo/webcomponents';
import { I18NextPipe } from 'angular-i18next';
import { AuthService, ORIGIN_URL_COOKIE_NAME } from './services/auth.service';
import { CompanyService } from './services/company.service';
import { TrackingService } from './services/tracking.service';
import { MiscService } from './services/misc.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly companyService = inject(CompanyService);
  private readonly router = inject(Router);
  private readonly trackingService = inject(TrackingService);
  private readonly i18NextService = inject(I18NextPipe);
  private readonly miscService = inject(MiscService);
  private readonly location = inject(Location);

  public isAuthenticated$ = this.authService.isAuthenticated$;

  public async ngOnInit(): Promise<void> {
    window.dispatchEvent(
      new CustomEvent('languageChanged', {
        detail: {
          language: navigator.language ?? 'en-US',
          labels: {}
        }
      })
    );

    this.authService.saveCookie(ORIGIN_URL_COOKIE_NAME, window.location.origin);

    await this.trackingService.init();

    try {
      if (!this.authService.isAuthenticated()) {
        throw new Error('User is not authenticated');
      }

      await this.authService.checkAccessToken(this.authService.getAccessToken());

      const company = await this.companyService.getCompany();

      this.trackingService.identify(
        this.authService.getUserID(),
        this.companyService.getCurrentCompany()?.companyCode ?? '',
        this.companyService.getCurrentCompany()?.id ?? ''
      );

      if (!company || !company?.isBrokers) {
        throw new Error(this.i18NextService.transform('login.error_bad_company'));
      }

      const fromRemote = this.miscService.isRemote();

      if (fromRemote) {
        return;
      }

      const termsAndConditionsAccepted = localStorage.getItem('termsAndConditionsAccepted');

      if (termsAndConditionsAccepted) {
        const currentPath = this.location.path();
        const isBaseOrTermsRoute = currentPath === '' || currentPath === '/' || currentPath === '/terms-and-conditions';

        if (isBaseOrTermsRoute) {
          this.router.navigate(['/home']);
        }
        return;
      }

      this.router.navigate(['/terms-and-conditions']);
    } catch (error) {
      BdeoToastService.error((error as Error).message);
      this.authService.logOut();
    }
  }
}
